import Flickity from 'flickity'
import Component from '../core/Component'

export default class SimpleGallery extends Component {
    constructor(element, options = {}) {
        super(element, options)
    
        this.ref = {
            slider: null,
            items: [],
            thumbs: []
        }
    }

    prepare() {
        this.flickity = new Flickity(this.ref.slider, {
            prevNextButtons: false,
            pageDots: false
        })

        this.ref.thumbs.forEach(thumb => {
            thumb.addEventListener('click', this.handleThumbClick)
        })
    }

    handleThumbClick = event => {
        const index = this.ref.thumbs.findIndex(thumb => thumb === event.currentTarget || thumb === event.target)
        if (!~index) {
            return
        }

        this.flickity.select(index + 1)
    }

}


// WEBPACK FOOTER //
// ./components/SimpleGallery.js